module.exports = __webpack_public_path__ + "bg68-dots-fe482bc8ab3b3302f1c83a73bcee786d.svg";